<template>
  <div class="floor-activity">
    <div class="activity-rows">
      <div
        v-for="(row, rowIndex) in layoutList"
        :key="rowIndex"
        class="activity-row"
      >
        <div
          v-for="(lineItem, lineIndex) in row.lineList"
          :key="lineIndex"
          class="row-item"
          :style="{
            height: lineItem.height + 'px'
          }"
        >
          <van-swipe
            class="activity-swiper"
            :autoplay="isPageActive && lineItem.retailHomepageDetails && lineItem.retailHomepageDetails.length > 1 ? 5000 : 0"
            :show-indicators="false"
          >
            <van-swipe-item
              v-for="(detail, detIndex) in lineItem.retailHomepageDetails"
              :key="detIndex"
              @click="onActivityClick(detail)"
            >
              <div class="swiper-item-content" :style="{ height: lineItem.height + 'px' }">
                <img
                  class="activity-image"
                  :src="detail.appImg || detail.wechatImg || detail.imageUrl"
                />
                <!-- 秒杀倒计时浮层 -->
                <div
                  v-if="seckillMap[detail.seckillId] && seckillMap[detail.seckillId].show"
                  class="seckill-overlay"
                  :class="lineItem.count === 3 ? 'pos-center' : 'pos-bottom'"
                >
                  <div class="countdown-box">
                    <span class="countdown-text">
                      {{ seckillMap[detail.seckillId].timeStr }}
                    </span>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { seckillHomeList } from "@/api/home";

export default {
  name: "HomeActivity",
  props: {
    floor: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ratios: [351 / 130.0, 173 / 130, 113 / 130.0],
      seckillModels: [],
      layoutList: [],
      seckillMap: {},
      timer: null,
      isPageActive: true
    };
  },
  watch: {
    floor: {
      immediate: true,
      handler(val) {
        if (val && val.columnList) {
          this.processLayout();
          this.fetchSeckillData();
        }
      }
    },
    seckillModels: {
      handler(newModels) {
        if (newModels && newModels.length > 0) {
          this.startTimer();
        }
      }
    }
  },
  activated() {
    this.isPageActive = true;
  },
  deactivated() {
    this.isPageActive = false;
  },
  beforeDestroy() {
    this.isPageActive = false;
    this.stopTimer();
  },
  methods: {
    processLayout() {
      if (!this.floor || !this.floor.columnList) return;
      const widthVal = window.innerWidth > 540 ? 375 : window.innerWidth;
      
      const layout = this.floor.columnList.map(row => {
        const count = row.lineList ? row.lineList.length : 0;
        if (count === 0) return null;

        // 两侧 padding 24px (12 * 2)
        const itemWidth = (widthVal - 24 - (count - 1) * 5) / count;
        const ratio = this.ratios[Math.min(count - 1, this.ratios.length - 1)];
        const itemHeight = itemWidth / ratio;

        const lineList = row.lineList.map(item => {
          return {
            ...item,
            width: itemWidth,
            height: itemHeight,
            count: count
          };
        });

        return {
          ...row,
          lineList
        };
      }).filter(i => i);

      this.layoutList = layout;
    },
    async fetchSeckillData() {
      if (!this.floor || !this.floor.columnList) return;

      const seckillIds = [];
      this.floor.columnList.forEach(col => {
        if (col.lineList) {
          col.lineList.forEach(line => {
            if (line.retailHomepageDetails) {
              line.retailHomepageDetails.forEach(detail => {
                if (detail.seckillId) {
                  seckillIds.push(detail.seckillId);
                }
              });
            }
          });
        }
      });

      if (seckillIds.length > 0) {
        try {
          const res = await seckillHomeList(seckillIds);
          if (res && res.code === 1) {
            this.seckillModels = res.data || [];
          }
        } catch (e) {
          console.error("获取秒杀数据失败", e);
        }
      }
    },
    startTimer() {
      this.stopTimer();
      this.updateSeckillTime();
      this.timer = setInterval(() => {
        this.updateSeckillTime();
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    updateSeckillTime() {
      if (!this.seckillModels || this.seckillModels.length === 0) return;
      const now = new Date().getTime();
      const map = {};

      this.seckillModels.forEach(model => {
        if (model.status === 2) {
          map[model.id] = { show: false };
          return;
        }

        let diff = 0;
        let isActive = false;

        if (model.startTime > now) {
          diff = model.startTime - now;
        } else if (model.endTime > now) {
          diff = model.endTime - now;
          isActive = true;
        } else {
          map[model.id] = { show: false };
          return;
        }

        map[model.id] = {
          show: true,
          timeStr: this.formatTime(diff),
          isActive
        };
      });

      this.seckillMap = map;
    },
    formatTime(ms) {
      if (ms <= 0) return "00:00:00";
      const s = Math.floor(ms / 1000);
      const h = Math.floor(s / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
    },
    onActivityClick(item) {
      this.$emit("click", item);
    }
  }
};
</script>

<style lang="less" scoped>
.floor-activity {
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
}
.activity-rows {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.activity-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 5px;
}
.row-item {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  border-radius: 6px;
  background-color: #f7f8fa;
}
.activity-swiper {
  width: 100%;
  height: 100%;
  ::v-deep .van-swipe-item {
    height: 100%;
  }
}
.swiper-item-content {
  width: 100%;
  position: relative;
  overflow: hidden;
  .activity-image {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}
.seckill-overlay {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 2;
  &.pos-bottom {
    bottom: 6px;
  }
  &.pos-center {
    top: 50%;
    transform: translateY(-50%);
  }
}
.countdown-box {
  background: rgba(0, 0, 0, 0.65);
  border-radius: 12px;
  padding: 2px 8px;
}
.countdown-text {
  font-size: 11px;
  color: #fff;
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
